import { Link } from 'react-router-dom'
import { Toasty } from '@talktoast/shared'

export function Hero() {
  return (
    <section className="bg-gradient-to-br from-warm-cream via-white to-butter-cream py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Status Badge */}
          <div className="inline-flex items-center gap-2 bg-toast-gold/10 text-toast-gold-700 px-4 py-2 rounded-full text-sm md:text-base font-semibold mb-6 shadow-sm">
            <span role="img" aria-label="Rocket">🚀</span>
            <span>Beta launching June 2026</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-deep-charcoal mb-6 leading-tight">
            Smart meals, friendly feel.
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl lg:text-2xl text-gray-600 mb-10 leading-relaxed max-w-3xl mx-auto">
            AI-powered meal planning that feels like chatting with a friend who loves food
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/beta-signup"
              className="w-full sm:w-auto bg-toast-gold hover:bg-toast-gold-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
              aria-label="Join TalkToast Beta Waitlist"
            >
              Join Beta Waitlist
            </Link>
            <a
              href="#features"
              className="w-full sm:w-auto bg-white hover:bg-gray-50 text-toast-gold-700 px-8 py-4 rounded-lg font-semibold text-lg border-2 border-toast-gold transition-all hover:shadow-md"
              aria-label="Learn more about TalkToast features"
            >
              Learn More
            </a>
          </div>

          {/* Visual Element */}
          <div className="mt-12 md:mt-16">
            <div className="relative w-32 h-32 md:w-40 md:h-40 mx-auto">
              <div className="absolute inset-0 bg-gradient-to-br from-toast-gold to-toast-gold-700 rounded-full opacity-20 animate-pulse"></div>
              <div className="relative flex items-center justify-center w-full h-full">
                <Toasty size="h-32 w-32 md:h-40 md:w-40" className="animate-pulse" alt="TalkToast mascot" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
